module.exports = __webpack_public_path__ + "static/media/emily-dixon.cd5dda1a.jpeg";